function limitarConteudo (conteudo, tamanho) {
  if (conteudo === null) {
    return '...'
  } else {
    const conteudoCortado = conteudo.substring(0, tamanho)
    if (conteudoCortado.length === conteudo.length) {
      return conteudo
    } else {
      return conteudoCortado + '...'
    }
  }
}

function retornarStringSeNulo (v) {
  if (v === null) {
    return ''
  }
  if (v === undefined) {
    return ''
  }
  return v
}

function retornarValorSeNulo (v) {
  if (v === null) {
    return parseFloat(0)
  }
  if (v === undefined) {
    return parseFloat(0)
  }
  if (isNaN(v)) {
    return parseFloat(0)
  }

  return parseFloat(v)
}

function formatarZeros (v, digitos) {
  // eslint-disable-next-line no-debugger
  // debugger
  if (v === null) {
    return ''
  }
  if (v === undefined) {
    return ''
  }
  if (isNaN(v)) {
    return ''
  }

  return String(v).padStart(digitos, '0')
}

function isEmpty (obj) {
  for (const prop in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(prop)) {
      return false
    }
  }

  return JSON.stringify(obj) === JSON.stringify({})
}

function isObjectEmpty (dados, field) {
  // console.log('aqui', dados, field)
  if (typeof (dados) === 'undefined') return true
  if (typeof (dados[field]) === 'undefined') return true
  if (dados[field] == null || (dados[field] === '' && typeof (dados[field]) !== 'boolean')) return true

  return false
}

function retornarValor (valor) {
  if (isNaN(valor)) return 0
  if (valor === null) return 0
  else if (valor === undefined) return 0
  else { return parseFloat(valor) }
}

function retornarMoeda (valor) {
  if (isNaN(valor)) return 0
  if (valor === null) return 0
  else if (valor === undefined) return 0
  else { return 'R$ ' + parseFloat(valor).toFixed(2) }
}

export default {
  limitarConteudo,
  retornarStringSeNulo,
  retornarValorSeNulo,
  formatarZeros,
  isEmpty,
  isObjectEmpty,
  retornarValor,
  retornarMoeda
}
